module.exports = __webpack_public_path__ + "static/media/r10.9ab5c35d.jpg";